import { Tooltip as MuiTooltip, type TooltipProps as MuiTooltipProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiTooltipProps, 'slots' | 'slotProps'>>;

export function Tooltip(props: Props) {
  return <MuiTooltip {...props} />;
}

export type { Props as TooltipProps };
